module.exports = __webpack_public_path__ + "static/media/OnBoarding_banor_tpOnboardingCreategroup.8222be06.png";